import { render, staticRenderFns } from "./SubCategoriesSidebar.vue?vue&type=template&id=8d79c3ae&"
import script from "./SubCategoriesSidebar.vue?vue&type=script&lang=js&"
export * from "./SubCategoriesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoriesSidebar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports